import React from 'react';
import styles from './container.module.scss';

const Container = ({ children, className }) => {
  return (
    <div className={`${styles.wrapper} ${className && className}`}>
      <div className={`${styles.container}`}>
        { children }
      </div>
    </div>
  );
};

export default Container;